import './style.css';
import '../styles/style.css';

import { CircularProgress } from '@material-ui/core';
import { bind } from 'bind-decorator';
import { observer, Provider } from 'mobx-react';
import type React from 'react';

import { Editor } from 'tm2-draft-js';

import DraftBase from '../base/draft-base';
import Debugger from '../draft/debugger';
import Errors from '../draft/errors';
import type FormStore from '../stores/form-store';

export interface IProps {
  className?: string;
  errors?: React.ReactNode[];
  store: FormStore;
  dataTestId?: string;
}

@observer
class Form extends DraftBase<IProps> {
  static defaultProps: Partial<IProps> = {
    className: ''
  };

  constructor(props: IProps) {
    super(props);

    this.styleMap = Object.assign(this.styleMap, {
      SUMMARY: { background: 'lightblue', display: 'inline-block' },
      HIGHLIGHT: { background: 'lightgreen', display: 'inline-block' }
    });
  }

  render() {
    let { store, className, dataTestId } = this.props;
    let { editor, highlight, errors, readOnly, blockRenderMap, loading, clonedConsultation } =
      store;

    let err;
    if (!readOnly) {
      err = <Errors value={errors} />;
    }

    let content = <CircularProgress />;
    if (!loading) {
      content = (
        <Editor
          customStyleMap={this.styleMap}
          blockRendererFn={this.blockRendererFn}
          blockRenderMap={blockRenderMap}
          blockStyleFn={this.blockStyleFn}
          editorState={editor}
          handleBeforeInput={this.onBeforeInput}
          readOnly={!highlight}
          style={{ minHeight: 400 }}
          onChange={this.onTemplate}
        />
      );
    }

    let cursor = highlight ? 'highlight' : '';
    const formClasses = `form live ${className} ${cursor} ${clonedConsultation ? 'border-4 border-amber-400 rounded-lg p-4' : ''}`;

    return (
      <Provider draftStore={store}>
        <div className={formClasses} data-testid={dataTestId}>
          <div className="editor-panel editor-content">{content}</div>
          <div>
            {err}
            {this.props.errors}
          </div>
          <Debugger store={store} />
        </div>
      </Provider>
    );
  }

  @bind
  onBeforeInput() {
    if (this.props.store.highlight) {
      return 'handled';
    }
  }

  @bind
  onTemplate(state) {
    this.props.store.onTemplate(state);
  }
}

export default Form;
